import { useMutation } from 'react-query';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { authFetchBlob } from '../../CommonUtils/authFetchBlob';

interface FetcherParams {
  clientId: string;
  date: string;
  accountId: string;
  groupId: string;
  selectedGroupName: string;
}

const downloadUnrealizedGainLossCsv = async ({
  clientId,
  accountId,
  groupId,
  date,
  selectedGroupName,
}: FetcherParams) => {
  return authFetchBlob(
    urlWithParams(
      '/Consumer/OrionAccountsWidgets/DownloadUnRealizedGainLossCsv',
      {
        clientId,
        asOfDate: date,
        accountId: accountId || null,
        groupId: groupId || null,
        selectedGroupName,
      },
      { skipNulls: true },
    ),
  );
};

export const useUnrealizedGainLossCsvMutation = () => {
  return useMutation(downloadUnrealizedGainLossCsv);
};
